import { Text } from "@meditect/medibase-components";

export const UserFirebaseUserNotFoundError = (): React.ReactElement => {
  return (
    <Text>
      Ce compte utilisateur est introuvable côté authentification. Veuillez contacter le support pour le rétablir.
    </Text>
  );
};
